export default __webpack_public_path__ + "static/media/speakar-watermark.30487df1.png";